import React, { useState, Suspense, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Home from "../../pages/Home/Home";
import OrderDetail from "../../pages/Order/OrderDetail";
import TermsAndConditions from "../../pages/TermsAndConditions/TermsAndConditions";
import NotFound from "../../pages/NotFound/NotFound";

function AllRoutes() {
    return (
        <>

            {/* ----------Whatsapp---------- */}
            <a href="https://api.whatsapp.com/send?phone=917011969546&text=Hi, I was browsing Partsklik and needed your support!"
                target="_blank" rel="noopener noreferrer" className="whatsapp_float">
                <i className="fa-brands fa-whatsapp whatsapp-icon"></i>

            </a>


            <Routes>
                <Route
                    path="/"
                    element={
                        <>
                            <Helmet>
                                <title>Partsklik LLP | India's Leading Marketplace for Car Spare Parts & Turbochargers</title>
                            </Helmet>
                            <Home />
                        </>
                    }
                />
                <Route
                    path="/order/:id"
                    element={
                        <>
                            <Helmet>
                                <title>Partsklik LLP | India's Leading Marketplace for Car Spare Parts & Turbochargers</title>
                            </Helmet>
                            <OrderDetail />
                        </>
                    }
                />

                <Route
                    path="/terms-and-conditions"
                    element={
                        <>
                            <Helmet>
                                <title>Terms & Conditions | Partsklik LLP</title>
                            </Helmet>
                            <TermsAndConditions />
                        </>
                    }
                />

                  <Route
                    path="*"
                    element={
                        <>
                            <Helmet>
                                <title>404 — Page Not Found | Partsklik LLP</title>
                            </Helmet>
                            <NotFound />
                        </>
                    }
                />


            </Routes>
        </>
    );
}

export default AllRoutes;